import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Why Us', href: '#why-us' },
    { name: 'Candidates', href: '#candidates' },
    { name: 'Careers', href: '#careers' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#faf8f5]/95 backdrop-blur-sm shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <nav className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <a href="#" className="flex flex-col items-start">
            <span
              className={`font-display text-xl lg:text-2xl tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#c9b896]' : 'text-[#c9b896]'
              }`}
              style={{ fontWeight: 500 }}
            >
              {companyInfo.name}
            </span>
            <span
              className={`text-xs tracking-wider transition-colors duration-300 ${
                isScrolled ? 'text-[#5a5652]' : 'text-[#faf8f5]/80'
              }`}
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {companyInfo.nameArabic}
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm tracking-widest uppercase transition-all duration-300 relative group ${
                  isScrolled
                    ? 'text-[#2c2825] hover:text-[#c9b896]'
                    : 'text-[#faf8f5] hover:text-[#c9b896]'
                }`}
                style={{ fontWeight: 400 }}
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#c9b896] transition-all duration-500 group-hover:w-full" />
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden p-2 transition-colors ${
              isScrolled ? 'text-[#2c2825]' : 'text-[#faf8f5]'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-[#faf8f5] shadow-lg transition-all duration-300 ${
          isMobileMenuOpen
            ? 'opacity-100 visible translate-y-0'
            : 'opacity-0 invisible -translate-y-4'
        }`}
      >
        <div className="px-6 py-8 flex flex-col gap-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-sm tracking-widest uppercase text-[#2c2825] hover:text-[#c9b896] transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
